import Parameter from "./parameter";
import IMigrationMapping from "../interface/migration-mapping";
import ParamStorage from "../enum/param-storage";
import ParameterStorage from "../class/parameter-storage";

class MigrationMappingSingleton {

    public async getAll(param: ParamStorage | null = null): Promise<IMigrationMapping[]> {
        await this.getStore().loadAll();
        return this.getStore().getAll().filter((m: IMigrationMapping) => {
            return param !== null ? m.param === param : null;
        });
    }

    public async get(param: ParamStorage, oldId: string): Promise<number | null> {
        const mapping: IMigrationMapping | null = (await this.getAll(param)).find(m => {
            return m.oldId === oldId;
        }) || null;
        return mapping ? mapping.newId : null;
    }

    public async create(param: ParamStorage, oldId: string, newId: number): Promise<IMigrationMapping> {
        return await this.getStore().create({ param, oldId, newId });
    }

    public async delete(id: number): Promise<number> {
        return await this.getStore().delete(id);
    }

    /* Private Methods - Parameter Storage */

    private getStore(): ParameterStorage<IMigrationMapping> {
        return Parameter.get(ParamStorage.MigrationMappings);
    }

}

const MigrationMapping = new MigrationMappingSingleton();

export default MigrationMapping;